<div class="container">
  <div class="row">
    <input [(ngModel)]="searchText" class="form-control col-md-8" placeholder="Search by design name" />
    
    <button *ngIf="!searchClicked" type="button" (click)="searchDesign()"
      class="btn btn-primary col-md-3 btn-srch  offset-md-1">Search</button>
    <button *ngIf="searchClicked" (click)="removeSearch()" type="button" class="btn btn-info col-md-3  offset-md-1">Reset</button>
  </div>
  <div class="dv-lst-dsign row">
    <div class="dv-desgn-blck" *ngFor="let item of designList">
      <div class="" (click)="openDesignStudio(item.DesignId)">
        <img *ngIf="!item.ImgLoaded" src="/assets/img/load-spinner.gif" alt="loading" />
        <img [src]="item.ProductUrl || 'assets/img/no-image-available.jpg'" [hidden]="!item.ImgLoaded"
          (load)="item.ImgLoaded=true">
      </div>
      <div class="dv-smll-img">
        <div *ngFor="let img of item.ImageList">
          <img *ngIf="!img.ImgLoaded" src="/assets/img/load-spinner.gif" alt="loading" />
          <img (click)="item.ProductUrl = img.ImageUrl " [src]="img.ImageUrl || 'assets/img/no-image-available.jpg'" [hidden]="!img.ImgLoaded"
            (load)="img.ImgLoaded=true">
        </div>
      </div>
      <p> {{item.DesignName}}</p>
    </div>
  </div>
</div>
